import {jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";import styled from '@emotion/styled'
import {Link} from '@mui/icons-material'

import CopyLink from '../../../../components/CopyLink'
import {PALETTE} from '../../../../styles/paletteV3'

const CopyIcon = styled('div')({
  color: 'inherit',
  display: 'block',
  height: 24,
  width: 24,
  marginRight: 12
})

const CopyLabel = styled('div')({
  color: 'inherit',
  fontSize: 'inherit',
  whiteSpace: 'nowrap'
})

const CopyBlock = styled('div')({
  alignItems: 'center',
  color: PALETTE.SLATE_600,
  display: 'flex',
  flexShrink: 0,
  fontSize: 'inherit',
  minWidth: 0,
  userSelect: 'none',
  overflow: 'auto',
  '&:hover': {
    color: PALETTE.SLATE_700,
    cursor: 'pointer'
  }
})











const CopyShortLink = (props) => {
  const {className, icon, label, url, title, tooltip, onCopy} = props
  const theLabel = label || url
  return (
    _jsx(CopyLink, { url: url, title: title, tooltip: tooltip, onCopy: onCopy, children: 
      _jsxs(CopyBlock, { className: className, children: [
        icon && (
          _jsx(CopyIcon, { children: 
            
              {
                link: _jsx(Link, {} )
              }[icon]
            
          })
        )
        , _jsx(CopyLabel, { children: theLabel})
      ]})
    })
  )
}

export default CopyShortLink
